export default "__VITE_ASSET__DI9bAq7q__"